import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Book } from './book'
import { BookTheme } from './category'

export const BookToBookTheme = pgTable(
  'book_to_book_theme',
  {
    bookId: uuid()
      .notNull()
      .references(() => Book.id, { onDelete: 'cascade' }),
    themeId: uuid()
      .notNull()
      .references(() => BookTheme.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.bookId, table.themeId] }),
    index('book_to_book_theme_book_idx').on(table.bookId),
    index('book_to_book_theme_theme_idx').on(table.themeId),
  ],
)

export const bookToBookThemeRelations = relations(BookToBookTheme, ({ one }) => ({
  book: one(Book, {
    fields: [BookToBookTheme.bookId],
    references: [Book.id],
  }),
  bookTheme: one(BookTheme, {
    fields: [BookToBookTheme.themeId],
    references: [BookTheme.id],
  }),
}))

export const InsertBookToBookThemeSchema = createInsertSchema(BookToBookTheme)
export const UpdateBookToBookThemeSchema = createUpdateSchema(BookToBookTheme).partial()
export const SelectBookToBookThemeSchema = createSelectSchema(BookToBookTheme)

export type InsertBookToBookTheme = typeof BookToBookTheme.$inferInsert
export type UpdateBookToBookTheme = z.infer<typeof UpdateBookToBookThemeSchema>
export type SelectBookToBookTheme = typeof BookToBookTheme.$inferSelect
